import { render, staticRenderFns } from "./ShieldModify.vue?vue&type=template&id=30a721b2&scoped=true&"
import script from "./ShieldModify.vue?vue&type=script&lang=js&"
export * from "./ShieldModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a721b2",
  null
  
)

export default component.exports